import { Table } from "../../../../s25-table/Table";
import ActionI = Table.ActionI;

export interface ShowDetailsParams {
    caller: "autoClick" | "manualClick" | any;
    toggleShowDetails: boolean;
    isExpandAll: boolean;
    occ?: {
        rowAction?: ActionI | string;
    };
    lastCallerTags?: string;
    currentCallerTags?: string;
}

export class ShowDetailsUtil {
    public static showDetailsUtil(params: ShowDetailsParams) {
        let action: string;
        let toggleShowDetails = params.toggleShowDetails;
        const { caller, isExpandAll, occ, lastCallerTags, currentCallerTags } = params;
        const hasRowAction = !!occ?.rowAction;

        if (hasRowAction) {
            const rowAction = occ!.rowAction;

            if (
                (caller === "autoClick" && isExpandAll && !toggleShowDetails && rowAction === "create") ||
                (caller === "autoClick" && !isExpandAll && toggleShowDetails && rowAction === "delete")
            ) {
                action = "noAction";
                toggleShowDetails = !toggleShowDetails; // icon changed
            } else {
                action = rowAction;
            }
        } else {
            action = toggleShowDetails ? "delete" : "create";
        }

        // Additional autoClick override when no rowAction is defined
        if (
            (!hasRowAction && caller === "autoClick" && !isExpandAll && toggleShowDetails) ||
            (!hasRowAction && caller === "autoClick" && isExpandAll && !toggleShowDetails)
        ) {
            action = "noAction";
        }

        toggleShowDetails = !toggleShowDetails;

        return { toggleShowDetails, action };
    }
}
